import type { TenantConfig } from 'types/config';

type AccessControl = NonNullable<
  NonNullable<TenantConfig['chatbotConfig']>['accessControl']
>;

type ChatbotUser =
  | {
      email?: string | null;
      telephone?: string | null;
    }
  | null
  | undefined;

// Wildcard '*' matches any run of chars; all other regex metachars are escaped.
const wildcardToRegExp = (pattern: string): RegExp => {
  const escaped = pattern
    .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
    .replace(/\*/g, '.*');
  return new RegExp(`^${escaped}$`, 'i');
};

const matchesAnyPattern = (value: string, patterns?: string[]): boolean =>
  (patterns ?? []).some((pattern) => wildcardToRegExp(pattern).test(value));

// Allowed when email matches any emailPatterns OR telephone is in the phones list.
// Blocked by default: missing accessControl or empty lists -> false.
export const isChatbotUserAllowed = (
  user: ChatbotUser,
  accessControl?: AccessControl,
): boolean => {
  if (!accessControl) return false;

  const { emailPatterns, phones } = accessControl;
  if (!emailPatterns?.length && !phones?.length) return false;

  const email = user?.email?.trim();
  const phone = user?.telephone?.trim();

  if (email && matchesAnyPattern(email, emailPatterns)) return true;
  if (phone && (phones ?? []).includes(phone)) return true;

  return false;
};
